import { useState, useEffect } from 'react'
type Props = {
  src: any
  alt?: string
}
const SmartLogo = (props: Props) => {
  const { src, alt = 'Logo' } = props
  const [height, setHeight] = useState('h-[40px]')

  useEffect(() => {
    const img = new Image()
    img.src = src

    img.onload = () => {
      const ratio = img.width / img.height

      // Adjust height based on aspect ratio
      if (ratio > 2.5)
        setHeight('h-[24px]') // very wide
      else if (ratio > 1.5)
        setHeight('h-[30px]') // wide rectangle
      else if (ratio > 1.1)
        setHeight('h-[40px]') // slightly wide
      else if (ratio >= 0.9)
        setHeight('h-[60px]') // near square
      else if (ratio >= 0.5)
        setHeight('h-[70px]') // vertical rectangle
      else setHeight('h-[80px]') // very tall
    }
  }, [src])

  return <img src={src} alt={alt} className={`mb-5 object-cover object-center ${height}`} />
}

export default SmartLogo
